/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React, { useState, useEffect } from "react";
import { 
  Modal, 
  Backdrop 
} from "@mui/material";
import { 
  StyledImageContainer,
  ImageCloseButton,
  StyledImagePreview,
} from "./styles";
import CloseIcon from '@mui/icons-material/Close'
import { Loader } from "../loader";

export const ImageViewer = ({ open, imageUrl, onClose, alt = 'Image preview' }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  useEffect(() => {
    setImageLoaded(false);
  }, [imageUrl])

  if(!imageUrl) return null;

  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
    >
      <StyledImageContainer data-testid="image-viewer">
        {
          !imageLoaded && (
            <Loader />
          )
        }
        {
          imageLoaded && (
            <ImageCloseButton
              onClick={onClose}
            >
              <CloseIcon />
            </ImageCloseButton>
          )
        }
        <StyledImagePreview
          src={imageUrl}
          alt={alt}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageLoaded(true)}
          imageLoaded={imageLoaded}
        />
      </StyledImageContainer>
    </Modal>
  )
}
